import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c81bc4aa&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=c81bc4aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81bc4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81bc4aa')) {
      api.createRecord('c81bc4aa', component.options)
    } else {
      api.reload('c81bc4aa', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c81bc4aa&scoped=true", function () {
      api.rerender('c81bc4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients-contacts/list.vue"
export default component.exports